export default __webpack_public_path__ + "static/media/icon_Course_Default.6d2a82eb.png";